// BatStateCache.js
//
// Last known state per battery rk (mode, level, inputW, outputW, ems).
// Overwritten per rk on every fetch/push — catalogue fields live in BatteryCache.
import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'BatStateCache';

class BatStateCache extends CacheBase2 {
    _name = _name;
}

const batStateCache = new BatStateCache();
export default batStateCache;
